<div fxLayout="row" class="background">

  <div fxFlex="75" fxFlexOffset="12%">

    <section id="header">
      <h1 class="h1Header">PEDIDOS COMPLETADOS</h1>
    </section>

    <div fxLayout="row" class="tablaCom">
      <div fxFlex=120 fxFlexOffset="-25%">
        <mat-card class="mat-elevation-z0">

          <mat-form-field appearance="outline">
            <mat-label>Buscar</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ingresar número de pedido" #input>
          </mat-form-field>

          <mat-table [dataSource]="dataSource" class="tabla">

            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef class="table-header"> ID</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">{{order.cdOrder}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="comercio">
              <mat-header-cell *matHeaderCellDef class="table-header">Comercio </mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content"> {{order.dsStoreName}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="usuario">
              <mat-header-cell *matHeaderCellDef class="table-header">Usuario</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content"> {{order.dsUserName}}<br> {{order.dsPhone}}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="direccion">
              <mat-header-cell *matHeaderCellDef class="table-header">Dirección</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content"> {{order.dsAddress}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="items">
              <mat-header-cell *matHeaderCellDef class="table-header"> Items</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">
                <button mat-button (click)="openOrder(order.cdOrder)">Ver</button>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="total">
              <mat-header-cell *matHeaderCellDef class="table-header">Total</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">{{order.qtTotal}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="opciones">
              <mat-header-cell *matHeaderCellDef class="table-header">Fecha Creación</mat-header-cell>
              <mat-cell *matCellDef="let order" class="table-content">
                Fecha
                <div class="detail">{{order.dtOrderDate | date:'HH:mm dd-MM-yyyy'}}</div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>

          <div *ngIf="dataSource.filteredData.length === 0" fxLayout="row" fxLayoutAlign="center center">
            <span class="cardHeader">
              No se encontraron pedidos con ese código</span>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

</div>
